export default __webpack_public_path__ + "static/media/bar-pois.d354eeaf.svg";